import findClosestLocations from '@/helpers/find-closest-locations';
import http from '@/services/http';



const shipping = {
  async getClosestShippingLocation({ address }) {
    try {
      const locations = await findClosestLocations({
        address,
        attributes: ['Shipping', 'WebOrdering']
      });

      return locations[0];
    }

    catch (error) {
      throw error;
    }
  },

  async validateAddress(options) {
    try {
      const { address, location } = options;

      const response = await http.post(`/cardfree-api/v1/shipping/${location.storeId}/validate`, {
        shipToAddress: {
          city: address.city,
          countryCode: address.countryCode,
          line1: address.line1,
          line2: address.line2,
          postalCode: address.postalCode,
          state: address.state
        }
      });

      return response.data;
    }

    catch (error) {
      throw error;
    }
  }
};



export default shipping;
